































import { Component, Vue, Prop } from 'vue-property-decorator'
import ButtonGroupComponent from '../buttons/ButtonGroupComponent.vue'
import ButtonComponent from '../buttons/ButtonComponent.vue'

@Component({
  components: {
    ButtonGroupComponent,
    ButtonComponent
  }
})

export default class PopUpComponent extends Vue {
  @Prop() public header!: string;
  @Prop() public mainBtn!: string;
  @Prop() public secondBtn?: string;
  @Prop() public description?: string;
  @Prop() public isLoading?: boolean;
  @Prop() public imgSrc?: string;
  @Prop() public closeIcon?: boolean;
}
